import { css } from '@emotion/core';

const columnHeaderDD = classes => css`
  ${classes && classes.structure.padding.space.left[2]}
  width: 200px;
  height: 32px;
  background-color: white;
  font-weight: normal;
  font-size: 12px;
  border-radius: 2px;
  height: 32px;
`;

export default (theme, width) => {
  const variables = theme && theme.variables;
  const classes = theme && theme.classes;
  return {
    chipWrapper: css`
      background: transparent;
      border: none;
      padding: 0;
      margin: 0;
      height: initial;
      cursor: pointer;

      &:focus {
        outline: 1px dashed black !important;
      }
    `,
    triggerInput: css`
      text-align: left !important;
      min-width: ${width} !important;
      ${classes && classes.structure.margin.space.bottom[2]}
    `,
    filterDropdown: css`
      ${columnHeaderDD(classes)}
    `,
    filterDropdownActive: css`
      ${columnHeaderDD(classes)}

      color: ${
        variables && variables.colors && variables.colors.action
          ? variables.colors.action.secondary.disabled
          : '#fff'
      };
      background-color: ${
        variables && variables.colors && variables.colors.action
          ? variables.colors.action.primary.default
          : '#003ea9'
      };
    `
  };
};
